import { Component, OnInit, Input, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class IconComponent implements OnInit {
  @Input()
  icon: string;
  
  @Input()
  size: string;

  get iconClass(): string {
    let cssClass = `fas fa-${this.icon}`;
    if (this.size) {
      cssClass += ` fa-${this.size}`;
    }

    return cssClass;
  }

  constructor() { }

  ngOnInit() {
  }

}
